import { ErrorBoundary as RollbarErrorBoundary } from '@rollbar/react'
import { ReactNode } from 'react'

function ErrorFallback() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-8 text-center">
      <h1 className="text-2xl font-semibold text-foreground">Something went wrong</h1>
      <p className="text-muted-foreground">
        An unexpected error occurred. Please refresh the page or contact support if the problem
        persists.
      </p>
      <button
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
        onClick={() => window.location.reload()}
      >
        Refresh page
      </button>
    </div>
  )
}

export function ErrorBoundary({ children }: { children: ReactNode }) {
  return <RollbarErrorBoundary fallbackUI={ErrorFallback}>{children}</RollbarErrorBoundary>
}
